import request from '@/request'

// 获取字典列表
export const queryDictList = (params: { dicType: string }): Promise<ResponseData<object>> => {
  return request.get('/pub/dic/query', { params, baseURL: '/portal-service-server' })
}
